function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function convertSizeArrayToString(sizes) {
  var szString = '';

  for (var i = 0; i < sizes.length; i += 1) {
    szString += "".concat(typeof sizes[i] === 'string' ? sizes[i] : sizes[i].join('x'), ",");
  }

  return szString.substring(0, szString.length - 1);
}

function getWidthsAndHeights(size) {
  var sizes = size.split(',');
  var widthsAndHeights = sizes.reduce(function (acc, val) {
    var dimensions = val.split('x');

    if (dimensions.length < 2) {
      return acc;
    }

    var newWidths = acc.widths.concat(parseInt(dimensions[0]));
    var newHeights = acc.heights.concat(parseInt(dimensions[1]));
    return _objectSpread(_objectSpread({}, acc), {}, {
      widths: newWidths,
      heights: newHeights
    });
  }, {
    widths: [],
    heights: []
  });
  return widthsAndHeights;
} // Converts sizes used by mobile ios ads (which are an array of arrays) into
// a comma-separated string. eg [[100,200],[50,150]] => '100x200,50x150'


var convertArrayToString = function convertArrayToString(sizes) {
  if (typeof sizes === 'string') {
    return sizes;
  }

  return convertSizeArrayToString(sizes);
};

var getInitialSize = function getInitialSize(size) {
  var widthsAndHeights = getWidthsAndHeights(size);
  var minWidth = Math.max.apply(null, widthsAndHeights.widths) + 1;
  var minHeight = Math.max.apply(null, widthsAndHeights.heights) + 1;
  return "".concat(minWidth, "x").concat(minHeight);
};

export { convertArrayToString, getInitialSize };
//# sourceMappingURL=transformer.js.map